export const parseHandoffIdParam = (raw: string | string[] | undefined): string | null => {
  const value = Array.isArray(raw) ? raw[0] : raw;

  if (value == null) {
    return null;
  }

  const parsed = Number(value);

  return Number.isFinite(parsed) && parsed > 0 ? value : null;
};

// The BFF sends contact ids as strings (the Uint scalar), but the contact queries
// take an Int, so every caller has to convert and reject ids that do not parse.
export const parseContactIdParam = (raw: string | null | undefined): number | null => {
  if (raw == null) {
    return null;
  }

  const parsed = Number(raw);

  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};
